module.exports = "/_next/static/images/new-jersey-0043a4f225f54b59aefe04cb379a0725.jpg.webp";